import styled from 'styled-components';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import { BorderColor, PrimaryColor, SidelyBlack, SurfaceColor } from '../../../styles/global/css/Utils';
import Triangle from 'images/icon/triangle.svg';
import { TOOLBARS_HEIGHT } from '../../../containers_v2/globals/defaultToolbar/style/Style';

interface ModalLeftProps {
	isOpen: boolean
}

const ModalLeftContainer = styled.div<ModalLeftProps>`
    transition: width 0.2s ease-out;
    display: flex;
    height: calc(100vh - ${TOOLBARS_HEIGHT}px);
    width: ${p => p.isOpen ? '290px' : '15px'};
    position: relative;
`;

const ModalLeftBlockContainer = styled.div<ModalLeftProps & { paddingLeft?: string }>`
    transition: display 0.2s ease-out;
    width: 100%;
    background-color: ${SurfaceColor};
    display: ${p => p.isOpen ? 'block' : 'none'};
    padding-left: ${p => p.paddingLeft ?? '0'};
    border-right: 1.5px solid ${BorderColor};
`;

const ModalLeftButton = styled.button<ModalLeftProps>`
    max-height: 82px;
    max-width: 13px;
    min-width: 13px;
    min-height: 82px;
    display: block;
    margin-top: 35vh;
    background-image: url(${Triangle});
    transform: ${p => p.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    background-repeat: no-repeat;
    background-position: center;
    background-color: ${PrimaryColor};
    border-style: none;
    cursor: pointer;
    border-radius: 3px;
    border-radius: ${p => p.isOpen ? '3px 0 0 3px' : '0 3px 3px 0'};
`;

const ModalLeftTitleContainer = styled.div`
    /* border-bottom-style: solid; */
    /* border-width: thin; */
    /* border-color: #edf1f3; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    padding-inline: 20px;
`;

const ModalLeftTitle = styled.h3`
    ${DefaultText}
    font-size: 14px;
    line-height: 16px;
    color: ${SidelyBlack};
    font-weight: 700;
`;

const ModalLeftReset = styled.p`
    ${DefaultText}
    height: fit-content;
    color: ${PrimaryColor};
    border: 1px solid ${PrimaryColor};
    cursor: pointer;
    padding: 3px 15px;
    border-radius: 5px;
    font-size: 11px;
`;


const ModalLeftBody = styled.div`
    ${DefaultText}
    padding-top: 10px;
    height: calc(100vh - ${TOOLBARS_HEIGHT + 50}px);
    overflow-y: auto;
`;

export {
	ModalLeftContainer,
	ModalLeftTitleContainer,
	ModalLeftTitle,
	ModalLeftBody,
	ModalLeftBlockContainer,
	ModalLeftButton,
	ModalLeftReset
};
